<template>
  <div>
    <!-- Image Fullscreen Preview -->
    <v-dialog v-model="filterDialog" maxWidth="450" persistent>
      <v-card class="pa-5 pt-6">
        <v-card-text>
          <v-layout row wrap justify-center align-center>
            <v-radio-group v-model="radioModel" row>
              <v-radio
                :label="$t('labels.allCountry')"
                value="radioAllCountry"
                class="mr-6"
              ></v-radio>
              <v-radio
                :label="$t('labels.myGroup')"
                value="radioMyGroup"
              ></v-radio>
            </v-radio-group>
          </v-layout>

          <v-combobox
            v-model="groupNameModel"
            :search-input.sync="groupName"
            v-on:keyup.enter="getGroups()"
            :items="groupItems"
            @keyup="upperCase"
            class="mt-5"
            hide-selected
            item-text="Name"
            item-value="Id"
            :label="$t('labels.myRegion')"
            return-object
            persistent-hint
            v-if="radioModel == 'radioMyGroup'"
          >
            <template v-slot:append>
              <v-btn
                v-if="loading"
                :loading="loading"
                @click="getGroups"
                :disabled="searchButtonDisabled"
                class="searchBtn"
                height="auto"
                text
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t('description.noContent') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>

          <small v-if="radioModel == 'radioMyGroup'" class="grey--text">
            {{ $t('description.searchDesc') }} <kbd class="mx-1">enter</kbd>
            {{ $t('description.pressButton') }}
          </small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-grey"
            class="white--text text-capitalize"
            text
            rounded
            :disabled="filterLoading"
            @click="closeDialog()"
          >
            {{ $t('buttons.cancelUpper') }}
          </v-btn>
          <v-btn
            color="blue-grey"
            class="white--text text-capitalize mr-3"
            outlined
            rounded
            :loading="filterLoading"
            @click="filterFeed()"
          >
            {{ $t('buttons.filter') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <v-btn
        @click="filterDialog = !filterDialog"
        height="50"
        dark
        class="mr-5 mb-4 px-0"
        elevation="0"
        color="defaultColorLightTwo"
        min-width="50"
        bottom
        right
        fixed
      >
        <v-icon class="px-0">mdi-tune</v-icon>
      </v-btn>

      <v-btn
        v-if="this.filterAlertStatus"
        :loading="filterLoading"
        depressed
        dark
        color="blue-grey mb-6 text-capitalize"
        style="right: 110px"
        bottom
        right
        fixed
        @click="deleteFilter"
      >
        {{ this.$store.state.filterGroupName }}
        <v-icon right dark> mdi-close-circle </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import GroupService from '../../services/GroupService';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      filterDialog: false,
      radioModel: 'radioAllCountry',

      loading: false,
      filterStatus: false,
      filterLoading: false,

      groupName: '',
      groupNameModel: null,
      groupItems: [],
    };
  },
  props: {},
  components: {},
  mounted() {},
  methods: {
    getGroups() {
      console.log('groupName :', this.groupName);
      this.loading = true;
      GroupService.getGroups(this.groupName)
        .then((res) => {
          console.log('groups :', res.data);
          this.groupItems = res.data;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.loading = false;
        });
    },
    upperCase() {
      //this.groupName = this.groupName.toLowerCase()
    },

    filterFeed() {
      console.log('filter : ', this.groupNameModel);
      if (this.radioModel == 'radioAllCountry') {
        this.setFilterGroupId({ groupId: null, groupName: null });
        this.filterLoading = true;
        this.getPosts().finally(() => {
          this.scrollTop();
          this.filterLoading = false;
          this.filterStatus = false;
          this.filterDialog = false;
        });
      } else {
        this.setFilterGroupId({
          groupId: this.groupNameModel.Id,
          groupName: this.groupNameModel.Name,
        });
        this.filterLoading = true;
        this.getPosts().finally(() => {
          this.scrollTop();
          this.filterLoading = false;
          this.filterStatus = true;
          this.filterDialog = false;
        });
      }
    },

    deleteFilter() {
      this.radioModel = 'radioAllCountry';
      this.filterFeed();
    },

    scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },

    closeDialog() {
      this.radioModel = 'radioAllCountry';

      this.loading = false;
      this.filterStatus = false;
      this.filterLoading = false;

      this.groupName = '';
      this.groupNameModel = null;
      (this.groupItems = []),
        this.setFilterGroupId({ groupId: null, groupName: null });

      this.filterDialog = false;
    },

    ...mapActions(['getPosts', 'setFilterGroupId']),
  },
  computed: {
    searchButtonDisabled() {
      return this.groupName < 3 ? true : false;
    },

    filterAlertStatus() {
      return this.$store.state.filterGroupId
        ? true
        : this.groupName && this.filterStatus;
    },
  },
};
</script>
